import { Routes } from '@angular/router';

export const routeUtils = {
  createLazySgAppRouteData(sgAppName: string, data?: any): any {
    return Object.assign(data || {}, { sgAppName });
  },

  /**
   * Performs a deep traversal of the route tree and returns all lazy routes.
   */
  extractLazyRoutes(routes: Routes): Routes {
    const lazyRoutes: Routes = [];
    for (const r of routes) {
      if (r.loadChildren) {
        lazyRoutes.push(r);
      } else if (r.children) {
        lazyRoutes.push(...routeUtils.extractLazyRoutes(r.children));
      }
    }
    return lazyRoutes;
  },
};
